var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone2020 = function SvgPhone2020(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone_20_20_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEE0E1",
    d: "M5.517 8.992a12.62 12.62 0 0 0 5.491 5.491l1.834-1.833a.83.83 0 0 1 .85-.2 9.5 9.5 0 0 0 2.975.475c.458 0 .833.375.833.833v2.909a.836.836 0 0 1-.833.833C8.842 17.5 2.5 11.158 2.5 3.333c0-.458.375-.833.833-.833H6.25c.458 0 .833.375.833.833 0 1.042.167 2.042.475 2.975a.84.84 0 0 1-.208.85z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone_20_20_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPhone2020;